import { NgModule } from '@angular/core';
import { MdToHtmlPipe } from './md-to-html.pipe';
import { SafeURLPipe } from './safe-url.pipe';

@NgModule({
  declarations: [MdToHtmlPipe, SafeURLPipe],
  exports: [MdToHtmlPipe, SafeURLPipe],
})
export class PipeModule {}
